import React from 'react'
import {useIntl} from 'react-intl'
import {Box, Button, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

// Recoverable product failure. Throwing HTTPError sends the shopper to the
// app error page ("This page isn't working") even when a refresh would succeed.
const ProductLoadError = () => {
    const {formatMessage} = useIntl()

    return (
        <Box data-testid="product-load-error" px={6} py={16} textAlign="center">
            <Text>
                {formatMessage({
                    id: 'product_detail.error.unable_to_load',
                    defaultMessage: "We couldn't load this product."
                })}
            </Text>
            <Button mt={4} onClick={() => window.location.reload()}>
                {formatMessage({
                    id: 'product_detail.error.refresh',
                    defaultMessage: 'Refresh the page'
                })}
            </Button>
        </Box>
    )
}

export default ProductLoadError
